// Reglas de cobro, las mismas del servidor (config/reglasPago.js): si cambia un número, se cambia en los dos.
import { dinero } from './dinero';

// Lo mínimo que Stripe cobra (tarjeta, OXXO y SPEI): ningún servicio, cotización ni reserva vale menos. Así nada es gratis: todo se
// paga en la plataforma
export const MINIMO_COBRO = 10;

// Lo más que acepta OXXO en un pago
export const OXXO_MAXIMO = 10000;

// SPEI y OXXO se pagan después de que el proveedor acepta, y el aviso del pago tarda (OXXO, hasta el siguiente día hábil): con menos
// anticipación que esto, solo con tarjeta
export const ANTICIPACION_HORAS = { spei: 24, oxxo: 72 };

const plazo = (horas) => (horas > 24 ? `${horas / 24} días` : `${horas} horas`);

// Por qué no se puede pagar así una reserva ('' si sí se puede). total: lo que se va a cobrar; instante: cuándo empieza el servicio (ms),
// o null mientras no se elige el horario
export const motivoSinMetodo = (metodo, { total = 0, instante = null } = {}) => {
  if (metodo === 'oxxo' && total > OXXO_MAXIMO) return `OXXO acepta pagos de hasta ${dinero(OXXO_MAXIMO)}`;
  const horas = ANTICIPACION_HORAS[metodo];
  if (horas && instante !== null && !(instante - Date.now() >= horas * 3600 * 1000)) return `Pide ${plazo(horas)} de anticipación`;
  return '';
};
